import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(({ spacing }) => ({
  text: {
    marginBottom: spacing(1.5)
  }
}));

export default useStyles;
